import { render, staticRenderFns } from "./businessCooperation.vue?vue&type=template&id=7677ed4e&scoped=true"
import script from "./businessCooperation.vue?vue&type=script&lang=js"
export * from "./businessCooperation.vue?vue&type=script&lang=js"
import style0 from "./businessCooperation.vue?vue&type=style&index=0&id=7677ed4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7677ed4e",
  null
  
)

export default component.exports